import React, { ChangeEvent } from "react";
import { UserDTO, UserxRole } from "../../../DTO/Userx";

interface UserFormProps {
    user: UserDTO;
    isNewUser: boolean;
    onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onRolesChange: (event: { value: string[] }) => void;
    onUserEnabledChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const UserForm: React.FC<UserFormProps> = ({
                                               user,
                                               isNewUser,
                                               onInputChange,
                                               onRolesChange,
                                               onUserEnabledChange,
                                           }) => {
    const userRoles = Object.values(UserxRole);

    return (
        <div>
            <div className="mb-6">
                <h1 className="text-2xl font-semibold text-primary">
                    {user.firstName} {user.lastName}
                </h1>
                <p className="text-sm text-text-secondary">{user.username}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="username" className="block text-sm font-medium text-on-surface mb-1">
                        Username
                    </label>
                    <input
                        id="username"
                        name="username"
                        value={user.username}
                        onChange={onInputChange}
                        required
                        placeholder="Username"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-on-surface mb-1">
                        First Name
                    </label>
                    <input
                        id="firstName"
                        name="firstName"
                        value={user.firstName}
                        onChange={onInputChange}
                        placeholder="First Name"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div>
                    <label htmlFor="lastName" className="block text-sm font-medium text-on-surface mb-1">
                        Last Name
                    </label>
                    <input
                        id="lastName"
                        name="lastName"
                        value={user.lastName}
                        onChange={onInputChange}
                        placeholder="Last Name"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-on-surface mb-1">
                        E-Mail
                    </label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        value={user.email ?? ""}
                        onChange={onInputChange}
                        placeholder="E-Mail"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-on-surface mb-1">
                        Password
                    </label>
                    <input
                        id="password"
                        name="password"
                        type="password"
                        value={user.password}
                        onChange={onInputChange}
                        placeholder="Password"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div>
                    <label htmlFor="roles" className="block text-sm font-medium text-on-surface mb-1">
                        Roles
                    </label>
                    <select
                        multiple
                        id="roles"
                        name="roles"
                        value={user.roles}
                        onChange={(e) =>
                            onRolesChange({
                                value: Array.from(e.target.selectedOptions, (opt) => opt.value),
                            })
                        }
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface"
                    >
                        {userRoles.map((role) => (
                            <option
                                key={role}
                                value={role}
                                className="bg-surface text-on-surface"
                            >
                                {role}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-on-surface mb-1">
                        Phone
                    </label>
                    <input
                        id="phone"
                        name="phone"
                        type="tel"
                        pattern="^\+\d{2}\s\d{3}\s\d{7}$"
                        value={user.phone ?? ""}
                        onChange={onInputChange}
                        placeholder="+43 123 1234567"
                        className="w-full bg-surface border border-border rounded-md px-3 py-2 text-on-surface placeholder-text-text-secondary"
                    />
                </div>

                <div className="flex items-center space-x-2 mt-6">
                    <input
                        id="enabled"
                        name="enabled"
                        type="checkbox"
                        checked={user.enabled}
                        onChange={onUserEnabledChange}
                        className="ml-2 h-5 w-5 text-primary bg-surface border border-border rounded"
                    />
                    <label htmlFor="enabled" className="text-sm font-medium text-on-surface">
                        Enabled
                    </label>
                </div>
            </div>
        </div>
    );
};

export default UserForm;
